export const svgIcons = () => {
  const HomeIcon = (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#FCFCFC"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.429 14.001H2.143c-.63 0-1.143-.504-1.143-1.125v-6.75c0-.62.512-1.125 1.143-1.125h2.286c.63 0 1.143.504 1.143 1.125v6.75c0 .621-.512 1.125-1.143 1.125zM12.43 9.501h2.666c.495 0 .976-.157 1.372-.45l2.761-2.038a1.752 1.752 0 0 1 2.264.158h0a1.684 1.684 0 0 1 0 2.41l-2.37 2.332a4.6 4.6 0 0 1-2.336 1.231l-3.35.66a4.642 4.642 0 0 1-2.005-.048l-3.029-.745a4.591 4.591 0 0 0-1.107-.135H5.572" />
        <path d="M12.43 9.501h1.697c.957 0 1.732-.762 1.732-1.704v-.34c0-.783-.54-1.465-1.311-1.654l-2.62-.644A5.46 5.46 0 0 0 10.626 5h0c-1.06 0-2.096.309-2.977.888L5.572 7.25" />
      </g>
    </svg>
  );
  const SessionIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke-linecap="round" stroke-linejoin="round" stroke="#FCFCFC">
        <path d="M12.696 3.113c-.895.309-1.778.708-2.696 1.222C7.457 2.91 5.184 2.343 2.174 2.246a.976.976 0 0 0-.997.98v11.605c0 .53.424.971.954.979 3.032.046 5.314.605 7.869 2.107 2.555-1.502 4.837-2.061 7.869-2.106a.977.977 0 0 0 .955-.98V3.226a.976.976 0 0 0-.998-.98c-.594.02-1.153.063-1.699.122" />
        <path d="M14.962 1.266a15.03 15.03 0 0 0-1.579.368.974.974 0 0 0-.687.94v4.113l1.716-1.144 1.715 1.144V2.233a.99.99 0 0 0-1.165-.967zM10 4.338v13.579" />
      </g>
    </svg>
  );
  const ScheduleIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(2.5 2.501)"
        stroke="#FFF"
        strokeWidth="1.25"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3.75 0v2.5M11.25 0v2.5" />
        <rect y="1.25" width="15" height="13.75" rx="2.5" />
      </g>
    </svg>
  );

  const RecordingsIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(1 1.001)"
        stroke="#FFF"
        strokeWidth="1.25"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="4" y="5.5" width="7" height="7" rx="1.346" />
        <path d="m11 10.164 2.009 1.238A.65.65 0 0 0 14 10.85V7.151a.65.65 0 0 0-.991-.553L11 7.836" />
        <rect width="18" height="18" rx="4.167" />
      </g>
    </svg>
  );

  const ProfileIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(.996 .996)"
        stroke="#FCFCFC"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="9.004" cy="9.004" r="9.004" />
        <path d="M12.616 13.506H5.391a.557.557 0 0 1-.556-.557v-.45a2.334 2.334 0 0 1 2.328-2.328h3.682a2.334 2.334 0 0 1 2.327 2.327v.451c0 .307-.249.556-.556.557zM9.004 8.003a2.25 2.25 0 1 1 0-4.502 2.25 2.25 0 0 1 0 4.502h0z" />
      </g>
    </svg>
  );
  const LogoutIcon = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M13 5.775v14.449a1.779 1.779 0 0 1-2.165 1.737l-4.446-.989a1.778 1.778 0 0 1-1.392-1.736V6.764c0-.834.58-1.556 1.393-1.736l4.446-.989A1.778 1.778 0 0 1 13 5.775zM9.999 14.02v-2M21.003 8.998V6.955a2 2 0 0 0-2-2H16M21.003 17.002v2a2 2 0 0 1-2 2.001H16M16.001 13h5.002M19.003 15l2-2-2-2"
          stroke="#FCFCFC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
  const ArticleIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#FFF"
        strokeWidth="1.5"
      >
        <path d="m18.414 6.415-2.828-2.828a2 2 0 0 0-1.414-.586H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7.83a2 2 0 0 0-.586-1.414h0z" />
        <path d="M19 8.001h-4a1 1 0 0 1-1-1v-4M8 11.001h6M8 14.001h6M8 17.001h4.33" />
      </g>
    </svg>
  );
  const TrackIcon = (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#FCFCFC"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.985 16.975V2M2 7.981l5.975-5.974 5.975 5.974" />
      </g>
    </svg>
  );
  const IconArrowDownBlackBig = (
    <svg
      width="29"
      height="35"
      viewBox="0 0 29 35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#000"
        strokeWidth="3"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14.048 2.02v29.96M2.074 20.014l11.954 11.952 11.954-11.952" />
      </g>
    </svg>
  );
  const IconArrowUpBlackBig = (
    <svg
      width="28"
      height="34"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.008 31.98L14.008 2.02M25.982 13.986L14.028 2.034L2.07401 13.986"
        stroke="#000"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const IconArrowDownWhiteMedium = (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#fff"
        strokeWidth="1.488"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.53 1.406v14.879M1.58 10.343l5.94 5.935 5.94-5.935" />
      </g>
    </svg>
  );
  const IconArrowUpWhiteMedium = (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#fff"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.985 16.975V2M2 7.981l5.975-5.974 5.975 5.974" />
      </g>
    </svg>
  );
  const IconArrowDownBlackSmall = (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.76 2.446V15.554M1.52 10.319L6.75 15.548L11.98 10.318"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const IconArrowUpBlackSmall = (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24 15.554L7.24 2.446M12.48 7.681L7.25 2.452L2.02 7.682"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const IconCompanyDetails = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#FFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10 5.417v1.666M7.837 9.583V7.917c0-.46.373-.834.834-.834h2.5c.46 0 .833.373.833.834v1.666M8.75 12.083h2.722M8.75 14.583h2.5"
        />
        <circle
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="10"
          cy="10"
          r="7.5"
        />
        <path
          d="M13.75 13.333v-2.916a.833.833 0 0 0-.833-.834H7.083a.833.833 0 0 0-.833.834v2.916"
          stroke="#FFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
  const IconDashboard = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="16.667"
          cy="3.333"
          r="1.667"
        />
        <path
          d="M17.5 7.5v5.833a4.167 4.167 0 0 1-4.167 4.167H6.667A4.167 4.167 0 0 1 2.5 13.333V6.667A4.167 4.167 0 0 1 6.667 2.5H12.5M13.333 7.5l-2.5 2.5M10.833 10 8.75 7.917M8.75 7.917 6.667 10M6.667 12.5h6.666"
          stroke="#FFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
  const IconDashboardActive = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="16.667"
          cy="3.333"
          r="1.667"
        />
        <path
          d="M17.5 7.5v5.833a4.167 4.167 0 0 1-4.167 4.167H6.667A4.167 4.167 0 0 1 2.5 13.333V6.667A4.167 4.167 0 0 1 6.667 2.5H12.5M13.333 7.5l-2.5 2.5M10.833 10 8.75 7.917M8.75 7.917 6.667 10M6.667 12.5h6.666"
          stroke="#e5b3ec"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
  const IconMembers = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M12.5 15.833v-.416A2.917 2.917 0 0 0 9.583 12.5H5.417A2.917 2.917 0 0 0 2.5 15.417v.416"
          stroke="#FFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="7.5"
          cy="6.25"
          r="2.917"
        />
        <path
          d="M18.333 15.833v-.416a2.917 2.917 0 0 0-2.916-2.917H15M13.333 3.333a2.917 2.917 0 0 1 0 5.834"
          stroke="#c"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );

  const IconSubscriptions = (
    <svg
      width="20.008"
      height="20.008"
      viewBox="0 0 20.008 20.008"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <ellipse
          stroke="#E5B3EC"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="7.503"
          cy="8.337"
          rx="5.002"
          ry="2.084"
        />
        <path
          d="M12.505 11.255c0 1.15-2.24 2.084-5.002 2.084-2.762 0-5.002-.933-5.002-2.084M17.507 8.337c0 1.15-2.24 2.084-5.002 2.084"
          stroke="#E5B3EC"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.505 8.337v6.252c0 1.151-2.24 2.085-5.002 2.085-2.762 0-5.002-.934-5.002-2.085V8.337M17.507 5.419v6.253c0 1.15-2.24 2.084-5.002 2.084"
          stroke="#E5B3EC"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.92 6.26a1.201 1.201 0 0 1-.417-.841c0-1.15 2.243-2.084 5.002-2.084 2.76 0 5.002.933 5.002 2.084 0 1.15-2.242 2.084-5.002 2.084-.142 0-.283 0-.417-.008"
          stroke="#E5B3EC"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
  const IconSwitchUser = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#FCFCFC"
          strokeWidth="1.5"
        >
          <path d="M5 12h14M10.001 17.001 5 12l5.001-5.001" />
        </g>
      </g>
    </svg>
  );
  const IconIntegrations = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(2.5 2.5)"
        stroke="#FFF"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width="15" height="15" rx="5" />
        <path d="M7.5 7.5v1.974M7.5 7.5l1.754-1.096M7.5 7.5 5.746 6.404M3.333 6.027v2.946c0 .596.318 1.146.834 1.444l2.5 1.443a1.667 1.667 0 0 0 1.666 0l2.5-1.443c.516-.298.834-.848.834-1.444V6.027c0-.596-.318-1.146-.834-1.444l-2.5-1.443a1.667 1.667 0 0 0-1.666 0l-2.5 1.443a1.667 1.667 0 0 0-.834 1.444z" />
      </g>
    </svg>
  );
  
  return {
    HomeIcon,
    SessionIcon,
    ScheduleIcon,
    RecordingsIcon,
    ArticleIcon,
    TrackIcon,
    ProfileIcon,
    LogoutIcon,
    IconArrowDownBlackBig,
    IconArrowUpBlackBig,
    IconArrowDownBlackSmall,
    IconArrowUpBlackSmall,
    IconArrowDownWhiteMedium,
    IconArrowUpWhiteMedium,
    IconCompanyDetails,
    IconDashboard,
    IconDashboardActive,
    IconMembers,
    IconSubscriptions,
    IconSwitchUser,
    IconIntegrations,
  };
};
